setTimeout(function() {
  // Attiva SOLO su desktop (larghezza >= 750px)
  if (window.innerWidth < 750) {
    console.log('Mobile detected - search history disabled');
    return;
  }
  
  (function() {
    'use strict';
    
    try {
      var MAX_HISTORY = 10;
      var form = document.getElementById('search-form-inline');
      var input = document.getElementById('search-input-inline');
      var dropdown = document.getElementById('search-history-dropdown');
      var preventBlur = false;
      var searchTimeout = null;
      var currentMode = 'history'; // 'history' o 'suggestions'
      
      if (!form || !input || !dropdown) return;
      
      console.log('Search history initialized (desktop only)');
      
      var getHistory = function() {
        try {
          var h = localStorage.getItem('meqqui_searchHistory');
          return h ? JSON.parse(h) : [];
        } catch (e) {
          return [];
        }
      };
      
      var saveHistory = function(query) {
        if (!query || !query.trim()) return;
        try {
          var h = getHistory();
          var t = query.trim();
          h = h.filter(function(i) { return i !== t; });
          h.unshift(t);
          h = h.slice(0, MAX_HISTORY);
          localStorage.setItem('meqqui_searchHistory', JSON.stringify(h));
        } catch (e) {}
      };
      
      var removeHistoryItem = function(query) {
        try {
          var h = getHistory();
          h = h.filter(function(i) { return i !== query; });
          localStorage.setItem('meqqui_searchHistory', JSON.stringify(h));
          preventBlur = true;
          showHistory();
          setTimeout(function() {
            input.focus();
            preventBlur = false;
          }, 10);
        } catch (e) {}
      };
      
      var clearHistory = function() {
        try {
          localStorage.removeItem('meqqui_searchHistory');
          dropdown.className = 'search-history-dropdown';
        } catch (e) {}
      };
      
      var escape = function(text) {
        return String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
      };
      
      var showHistory = function() {
        currentMode = 'history';
        var h = getHistory();
        if (h.length === 0) {
          dropdown.className = 'search-history-dropdown';
          return;
        }
        
        var html = '<div class="search-history-header">';
        html += '<div class="search-history-title">Ricerche recenti</div>';
        html += '<button type="button" class="search-history-clear">Cancella tutto</button>';
        html += '</div>';
        
        for (var i = 0; i < h.length; i++) {
          var q = escape(h[i]);
          html += '<div class="search-history-item" data-query="' + q + '">';
          html += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" class="search-history-icon">';
          html += '<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M10 5v5l3 3M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"/></svg>';
          html += '<span>' + q + '</span>';
          html += '<button type="button" class="search-history-remove" data-query="' + q + '">';
          html += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">';
          html += '<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 5L5 15M5 5l10 10"/>';
          html += '</svg>';
          html += '</button>';
          html += '</div>';
        }
        
        dropdown.innerHTML = html;
        dropdown.className = 'search-history-dropdown is-visible';
        
        attachHistoryListeners();
      };
      
      var showSuggestions = function(query) {
        currentMode = 'suggestions';
        
        // Mostra loader
        dropdown.innerHTML = '<div class="search-suggestions-loading">Ricerca in corso...</div>';
        dropdown.className = 'search-history-dropdown is-visible';
        
        // Fetch suggerimenti prodotti
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=5')
          .then(function(response) {
            return response.json();
          })
          .then(function(data) {
            var products = data.resources.results.products || [];
            
            if (products.length === 0) {
              dropdown.innerHTML = '<div class="search-suggestions-empty">Nessun prodotto trovato</div>';
              return;
            }
            
            var html = '<div class="search-history-header">';
            html += '<div class="search-history-title">Prodotti suggeriti</div>';
            html += '</div>';
            
            for (var i = 0; i < products.length; i++) {
              var product = products[i];
              var imageUrl = product.image ? product.image : '';
              var price = product.price || '';
              
              html += '<a href="' + product.url + '" class="search-suggestion-item">';
              if (imageUrl) {
                html += '<img src="' + imageUrl + '" alt="' + escape(product.title) + '" class="search-suggestion-image">';
              }
              html += '<div class="search-suggestion-info">';
              html += '<div class="search-suggestion-title">' + escape(product.title) + '</div>';
              if (price) {
                html += '<div class="search-suggestion-price">€' + price + '</div>';
              }
              html += '</div>';
              html += '</a>';
            }
            
            dropdown.innerHTML = html;
            dropdown.className = 'search-history-dropdown is-visible';
          })
          .catch(function(error) {
            console.error('Search suggestions error:', error);
            dropdown.innerHTML = '<div class="search-suggestions-empty">Errore nel caricamento</div>';
          });
      };
      
      var attachHistoryListeners = function() {
        // Click sugli item
        var items = dropdown.querySelectorAll('.search-history-item');
        for (var j = 0; j < items.length; j++) {
          (function(item) {
            item.onclick = function(e) {
              if (e.target.closest('.search-history-remove')) return;
              e.preventDefault();
              e.stopPropagation();
              input.value = item.getAttribute('data-query');
              dropdown.className = 'search-history-dropdown';
              form.submit();
            };
          })(items[j]);
        }
        
        // Click sui pulsanti remove
        var removeButtons = dropdown.querySelectorAll('.search-history-remove');
        for (var k = 0; k < removeButtons.length; k++) {
          (function(btn) {
            btn.onmousedown = function(e) {
              e.preventDefault();
            };
            btn.onclick = function(e) {
              e.preventDefault();
              e.stopPropagation();
              var query = btn.getAttribute('data-query');
              removeHistoryItem(query);
            };
          })(removeButtons[k]);
        }
        
        // Click sul pulsante cancella tutto
        var clearBtn = dropdown.querySelector('.search-history-clear');
        if (clearBtn) {
          clearBtn.onclick = function(e) {
            e.preventDefault();
            e.stopPropagation();
            clearHistory();
          };
        }
      };
      
      var hide = function() {
        if (preventBlur) return;
        setTimeout(function() {
          dropdown.className = 'search-history-dropdown';
        }, 200);
      };
      
      var handleInput = function() {
        var query = input.value.trim();
        
        // Cancella il timeout precedente
        if (searchTimeout) {
          clearTimeout(searchTimeout);
        }
        
        // Se l'input è vuoto, mostra lo storico
        if (query === '') {
          showHistory();
          return;
        }
        
        // Aspetta 300ms prima di fare la ricerca
        searchTimeout = setTimeout(function() {
          showSuggestions(query);
        }, 300);
      };
      
      input.addEventListener('focus', function() {
        if (input.value.trim() === '') {
          showHistory();
        } else {
          handleInput();
        }
      }, false);
      
      input.addEventListener('click', function() {
        if (input.value.trim() === '') {
          showHistory();
        }
      }, false);
      
      input.addEventListener('input', handleInput, false);
      input.addEventListener('blur', hide, false);
      
      form.addEventListener('submit', function() {
        saveHistory(input.value);
      }, false);
      
      document.addEventListener('click', function(e) {
        var target = e.target;
        var inForm = false;
        var inDropdown = false;
        
        while (target) {
          if (target === form) inForm = true;
          if (target === dropdown) inDropdown = true;
          target = target.parentNode;
        }
        
        if (!inForm && !inDropdown) {
          dropdown.className = 'search-history-dropdown';
        }
      }, false);
      
    } catch (error) {
      console.error('Search history error:', error);
    }
  })();
}, 100);